import { useQuery } from "react-query";
import { useIntl } from "react-intl";
import {
  BaseFilter,
  ListRequestOfBaseFilter,
  OrganizationModel,
} from "services/KnowfullyAdminClient";
import useGlobalContext from "hooks/globalData";
import AutocompleteWithQuery, {
  AutocompleteWithQueryProps,
} from "components/AutocompleteWithQuery";

type SelectOrganizationProps = {
  organizationIds?: string[];
} & Omit<
  AutocompleteWithQueryProps<OrganizationModel>,
  "fetchedData" | "failMessage" | "labelField"
>;

const SelectOrganization = ({
  organizationIds,
  ...rest
}: SelectOrganizationProps) => {
  const { formatMessage: t } = useIntl();
  const { organizationService } = useGlobalContext();
  const fetchedData = useQuery(["getOrganizations", organizationIds], () =>
    organizationService.getOrganizations(
      ListRequestOfBaseFilter.fromJS({
        sortField: "name",
        parameters: BaseFilter.fromJS({ includedIds: organizationIds }),
      })
    )
  );

  return (
    <AutocompleteWithQuery
      {...rest}
      labelField="name"
      fetchedData={fetchedData}
      failMessage={t({ id: "fetchError" })}
    />
  );
};

export default SelectOrganization;
